import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit {
  @Input() totalItems: number = 0;
  @Input() pageSize: number = 1;

  constructor() { }

  ngOnInit(): void {
  }

}
